import React, { useEffect, useState } from "react";
import Notify from "../../../Notify";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormHelperText,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { getData } from "../../../../services/library";
import AgregarCoordenadasEnv from "../NuevoPedido/agregarCoordenadas/AgregarCoordenadasEnv";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import AltaDireccionEnv from "../../clientesEnvasado/fichaCliente/direcciones/AltaDireccionEnv";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import moment from "moment";
import { Delete, AddCircleOutline } from "@mui/icons-material";
import { UrlApi } from "../../../../services/apirest";

function ReprogramarPedido(props) {
    const [notificacion, setNotificacion] = useState({
        open: false,
        mensaje: "",
        severity: "",
        color: "",
      });
      const style = {
        backgroundColor: "#ffffff",
        width: "100%",
      };
      const [renglones, setRenglones] = useState();
      const [direcciones, setDirecciones] = useState();
      const [direccionSeleccionada, setdireccionSeleccionada] = useState("");
      const [buscando, setBuscando] = useState(false);
      const [agregarCoordenadas, setAgregarCoordenadas] = useState(false);
      const [abrirCoordenadas, setAbrirCoordenadas] = useState(false);
      const [tabla, setTabla] = useState(true);
      const [nuevaDireccion, setNuevaDireccion] = useState(false);
      const [clienteSeleccionado, setClienteSeleccionado] = useState({
        id: props.dataPedido.id_cliente,
        razon_social: props.dataPedido.cliente,
      });
      const [productos, setProductos] = useState();
      const [productoSeleccionado, setProductoSeleccionado] = useState("");
      const [datosRenglon, setDatosRenglon] = useState([]);
      const [datosPedido, setdatosPedido] = useState({
        observaciones: props.dataPedido.observaciones,
        fecha_para: moment(props.dataPedido.fecha_para, "DD/MM/YYYY HH:mm").format("YYYY-MM-DD HH:mm:ss"),
      });
      
      const [disabled, setDisabled] = useState(false)
    
      const obtenerDirecciones = () => {
        getData(
          "/envasado_direcciones_entrega/cli/" + props.dataPedido.id_cliente,
          setDirecciones
        );
      };
      const obtenerRenglones = () => {
        getData(
          "/envasado_pedidos_renglon/renglones/" + props.dataPedido.uuid_pedido,
          setRenglones
        );
      };
    
      useEffect(() => {
        getData("/productos/envasados", setProductos);
      }, [tabla]);
    
      useEffect(() => {
        obtenerRenglones();
        obtenerDirecciones();
      }, []);
    
      useEffect(() => {
        setDatosRenglon(renglones)
      }, [renglones])
    
    
      const almacenar = (e) => {
        setdatosPedido({
          ...datosPedido,
          [e.target.name]: e.target.value,
        });
      };
    
      const handleClickAgregarCoordenadas = () => {
        setAbrirCoordenadas(true); //pongo alta en true para q muestre el componente Addcliente
        setTabla(false); //tabla en false para que no se muestre la tabla
      };
    
      const handleCloseAgregarCoordenadas = () => {
        setAbrirCoordenadas(false);
        setTabla(true);
      };
    
      const handleClickNuevaDireccion = () => {
        setNuevaDireccion(true); //pongo alta en true para q muestre el componente Addcliente
        setTabla(false); //tabla en false para que no se muestre la tabla
      };
    
      const handleCloseDireccion = () => {
        setNuevaDireccion(false);
        setTabla(true);
      };
    
      const handleProductoChange = (index, value) => {
        const nuevasLineas = [...datosRenglon];
        nuevasLineas[index].producto = value ? value.idproducto : null;
        setDatosRenglon(nuevasLineas);
      };
    
      const handleCantidadChange = (index, value) => {
        const nuevasLineas = [...datosRenglon];
        nuevasLineas[index].cantidad = value;
        setDatosRenglon(nuevasLineas);
      };
    
      const handleEspecificacionesChange = (index, value) => {
        const nuevasLineas = [...datosRenglon];
        nuevasLineas[index].especificaciones = value;
        setDatosRenglon(nuevasLineas);
      };
    
      const deshacerAlmacenar = (index) => {
        const nuevasLineas = [...datosRenglon];
        nuevasLineas[index].eliminado = true; // Marcar como eliminado
        setDatosRenglon(nuevasLineas);
      };
    
      const agregarLinea = () => {
        const nuevaLinea = {
          uuid_pedido: props.dataPedido.uuid_pedido,
          producto: null,
          cantidad: 1,
          especificaciones: "",
        };
        setDatosRenglon((prevLineas) => [...prevLineas, nuevaLinea]);
      };
    
      const getProductoById = (id) => {
        return productos
          ? productos.find((producto) => producto.idproducto === id)
          : null;
      };
    
      useEffect(() => {
        // provincia
        if (direccionSeleccionada === "") {
          if (props.dataPedido.id_direccion !== "" && direcciones) {
            const direccionEncontrada = direcciones.find(
              (d) => d.id === props.dataPedido.id_direccion
            );
            if (direccionEncontrada) {
              setdireccionSeleccionada(direccionEncontrada);
            }
          }
        }
      }, [direcciones]);
    
      const guardarPedido = async (e) => {
          setDisabled(true)
          await fetch(UrlApi + "/envasado_pedidos/"+props.dataPedido.id, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id_direccion: direccionSeleccionada.id,
              fecha_para: datosPedido.fecha_para,
              observaciones: datosPedido.observaciones,
              estado:245,
              usuario: localStorage.getItem("user"),
            }),
          })
            .then((res) => {
              if (!res.err) {
                // PONGO EL UPDATE EN TRUE PARA QUE LA TABLA SE ACTUALICE CON CADA ACTUALIZACION EN LOS DATOS
                console.log("Guardado");
              } else {
                console.log("Error");
              }
            })
            .catch((err) => {
              console.log(err.message);
            });
      
            for (let i = 0; i < datosRenglon.length; i++) {
              const element = datosRenglon[i];
          
              if (element.eliminado) {
                // Desactivar renglón en la base de datos
                await fetch(`${UrlApi}/envasado_pedidos_renglon/${element.id}`, {
                  method: "PUT",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ activo: 0, usuario: localStorage.getItem("user") }),
                });
              } else if (element.id) {
                // Actualizar renglón existente
                await fetch(`${UrlApi}/envasado_pedidos_renglon/${element.id}`, {
                  method: "PUT",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    producto: element.producto,
                    cantidad: element.cantidad,
                    especificaciones: element.especificaciones,
                    usuario: localStorage.getItem("user"),
                  }),
                });
              } else {
                // Insertar nuevo renglón
                await fetch(UrlApi + "/envasado_pedidos_renglon", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    uuid_pedido: props.dataPedido.uuid_pedido,
                    producto: element.producto,
                    cantidad: element.cantidad,
                    especificaciones: element.especificaciones,
                    usuario: localStorage.getItem("user"),
                  }),
                });
              }
            }
          
            handleClose();
        };
      
        const handleClose = () => {
          props.setOpen(false);
        };
    
      return (
        <div>
          {tabla ? (
            <Dialog
              fullWidth
              open={props.open}
              onClose={() => props.setOpen(false)}
              maxWidth="xl"
            >
              {notificacion && notificacion.open ? (
                <Notify
                  mensaje={notificacion.mensaje}
                  open={notificacion.open}
                  color={notificacion.color}
                  handleClose={() => {
                    props.setOpen(false);
                  }}
                  severity={notificacion.severity}
                />
              ) : null}
              <Box justifyContent="center" backgroundColor="#1F618D">
                <DialogTitle>
                  <Typography variant="h6" align="center" color="#ffffff">
                    Reprogramar Pedido N°{props.dataPedido.id}
                  </Typography>
                </DialogTitle>
              </Box>
              <DialogContent>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <TextField
                      label="Cliente"
                      name="cliente"
                      size="small"
                      focused
                      required
                      fullWidth
                      autoComplete="off"
                      value={props.dataPedido.cliente}
                      // onChange={almacenar}
                    />
                  </Grid>
                  <Grid item xs={5.5}>
                    {buscando === true ? (
                      <TextField
                        disabled
                        focused
                        fullWidth
                        label="Buscando Direcciones..."
                      />
                    ) : (
                      <>
                        <Autocomplete
                          disabled={!direcciones}
                          required
                          disableClearable
                          id="direccion"
                          style={style}
                          size="small"
                          noOptionsText={"Direccion INEXISTENTE"}
                          options={direcciones}
                          autoHighlight
                          getOptionLabel={(direccion) =>
                            direccion.direccion_entrega
                          }
                          isOptionEqualToValue={(option, value) =>
                            option.id === value?.id
                          }
                          value={direccionSeleccionada || null}
                          defaultValue={direccionSeleccionada || null}
                          onChange={(event, value) => {
                            setdireccionSeleccionada(value);
                          }}
                          renderOption={(props, option) => (
                            <Box
                              component="li"
                              key={option.id}
                              sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                              {...props}
                            >
                              {option.direccion_entrega}
                            </Box>
                          )}
                          renderInput={(params) => (
                            <TextField
                              placeholder="Tipee para buscar..."
                              {...params}
                              label="Direccion"
                              focused
                              inputProps={{
                                ...params.inputProps,
                              }}
                            />
                          )}
                        />
                        {agregarCoordenadas === true ? (
                          <FormHelperText
                            sx={{ bgcolor: "lemonchiffon", color: "#5D6D7E" }}
                          >
                            La Dirección de Entrega no tiene coordenadas, para
                            agregarlas pulse "Agregar Coordenadas"
                          </FormHelperText>
                        ) : null}
                      </>
                    )}
                  </Grid>
                  {agregarCoordenadas ? (
                    <Grid item xs={0.5}>
                      <Tooltip title={`Agregar coordenadas`}>
                        <IconButton
                          color="secondary"
                          onClick={() => {
                            handleClickAgregarCoordenadas();
                          }}
                        >
                          <AddLocationAltIcon />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  ) : null}
                  <Grid item xs={0.5}>
                    <Tooltip
                      title={`Agregar direccion a ${props.dataPedido.cliente}`}
                    >
                      <IconButton
                        // variant="outlined"
                        color="primary"
                        onClick={() => {
                          handleClickNuevaDireccion();
                        }}
                      >
                        <AddCircleIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
    
                  <Grid item xs={12} mr={3}>
                    {direccionSeleccionada ? (
                      <Box
                        sx={{
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                          padding: "10px",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                          backgroundColor: "#f9f9f9",
                          width: "100%",
                        }}
                      >
                        <Grid container spacing={1}>
                          <Grid item xs={4}>
                            <TextField
                              fullWidth={true}
                              focused
                              size="small"
                              type="datetime-local"
                              required
                              placeholder="Fecha "
                              name="fecha_para"
                              label="Fecha de Pedido"
                              variant="outlined"
                              value={moment(datosPedido.fecha_para).format(
                                "YYYY-MM-DDTHH:mm"
                              )}
                              onChange={almacenar}
                            />
                          </Grid>
                          <Grid item xs={8}>
                            <TextField
                              label="Observaciones"
                              name="observaciones"
                              size="small"
                              focused
                              required
                              fullWidth
                              autoComplete="off"
                              value={datosPedido.observaciones}
                              onChange={almacenar}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    ) : null}
                  </Grid>
                  <Grid item xs={12} mr={3}>
                  {direccionSeleccionada ? (
                    <Box
                      sx={{
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        padding: "10px",
                        margin: "5px 0",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        backgroundColor: "#f9f9f9",
                        width: "100%",
                      }}
                    >
                      {datosRenglon
                        ? datosRenglon
                        .filter((linea) => !linea.eliminado)
                        .map((linea, index) => (
                            <div
                              key={index}
                              style={{
                                paddingBottom: "4px",
                                paddingLeft: "3px",
                                paddingTop: "10px",
                              }}
                            >
                              <Grid container spacing={2}>
                                <Grid item xs={5}>
                                  {productos && (
                                    <Autocomplete
                                      disabled={!productos}
                                      disableClearable
                                      size="small"
                                      required
                                      noOptionsText={"Producto INEXISTENTE"}
                                      options={productos}
                                      autoHighlight
                                      getOptionLabel={(producto) =>
                                        producto.codigoproducto +
                                        "-" +
                                        producto.nombre
                                      }
                                      value={getProductoById(linea.producto)}
                                      onChange={(event, value) => {
                                        handleProductoChange(index, value);
                                        setProductoSeleccionado(value);
                                      }}
                                      renderOption={(props, option) => (
                                        <Box
                                          component="li"
                                          key={option.id}
                                          sx={{
                                            "& > img": { mr: 2, flexShrink: 0 },
                                          }}
                                          {...props}
                                        >
                                          {option.codigoproducto} - {option.nombre}
                                        </Box>
                                      )}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          inputProps={{
                                            ...params.inputProps,
                                          }}
                                          focused
                                          size="small"
                                          placeholder="Tipee para buscar..."
                                          label="Producto"
                                        />
                                      )}
                                    />
                                  )}
                                </Grid>
    
                                <Grid item xs={1}>
                                  <TextField
                                    label="Cantidad"
                                    name="cantidad"
                                    size="small"
                                    type="number"
                                    focused
                                    required
                                    fullWidth
                                    autoComplete="off"
                                    value={linea.cantidad || ""}
                                    onChange={(e) =>
                                      handleCantidadChange(index, e.target.value)
                                    }
                                  />
                                </Grid>
                                <Grid item xs={5}>
                                  <TextField
                                    label="Especificaciones"
                                    name="especificaciones"
                                    size="small"
                                    focused
                                    required
                                    fullWidth
                                    autoComplete="off"
                                    value={linea.especificaciones || ""}
                                    onChange={(e) =>
                                      handleEspecificacionesChange(
                                        index,
                                        e.target.value
                                      )
                                    }
                                  />
                                </Grid>
                                <Grid
                                  item
                                  xs={1}
                                  fullWidth
                                >
                                  {" "}
                                  {/* Columna para los iconos */}
                                  {index > 0 && (
                                  <Tooltip title="Eliminar línea">
                                    <IconButton
                                      variant="outlined"
                                      color="error"
                                      onClick={() => deshacerAlmacenar(index)}
                                    >
                                      <Delete />
                                    </IconButton>
                                  </Tooltip>)}
                                  {index === datosRenglon.length - 1 && (
                                    <Tooltip title="Agregar línea">
                                      <IconButton
                                        variant="outlined"
                                        color="primary"
                                        onClick={() => {
                                          agregarLinea();
                                        }}
                                      >
                                        <AddCircleOutline />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </Grid>
                              </Grid>
                            </div>
                          ))
                        : null}
                    </Box>
                  ) : null}
                  </Grid>
                </Grid>
                <Grid
                  mt={1}
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Button
                    // disabled={disBtn}
                    variant="contained"
                    onClick={() => props.setOpen(false)}
                    color="error"
                  >
                    Volver
                  </Button>
                  <Button
                    disabled={disabled}
                    variant="contained"
                    onClick={guardarPedido}
                    color="success"
                  >
                    Guardar
                  </Button>
                </Grid>
              </DialogContent>
            </Dialog>
          ) : null}
    
          {abrirCoordenadas ? (
            <AgregarCoordenadasEnv
              open={abrirCoordenadas}
              setOpen={setAbrirCoordenadas}
              direccionSeleccionada={direccionSeleccionada}
              onClose={handleCloseAgregarCoordenadas}
            />
          ) : null}
          {nuevaDireccion ? (
            <AltaDireccionEnv
              open={nuevaDireccion}
              setOpen={setNuevaDireccion}
              cliente={clienteSeleccionado}
              onClose={handleCloseDireccion}
            />
          ) : null}
        </div>
  )
}

export default ReprogramarPedido